module.exports = __webpack_public_path__ + "img/21.826846bd.jpg";